import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api/axiosConfig';
import { showErrorAlert } from '../utils/alert';
import './LoginPage.css'; // Kita bisa gunakan kembali style halaman login untuk layout
import logo from '../assets/images/logo.png';

const ServiceResponsePage = () => {
  const { token } = useParams(); // Ambil token dari URL

  const [serviceInfo, setServiceInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [catatan, setCatatan] = useState('');

  useEffect(() => {
    const fetchServiceInfo = async () => {
      try {
        const { data } = await api.get(`/api/service-response/${token}`);
        setServiceInfo(data);
      } catch (err) {
        setError(err.response?.data?.message || 'Link tidak valid atau sudah kedaluwarsa.');
      } finally {
        setLoading(false);
      }
    };
    if (token) {
      fetchServiceInfo();
    }
  }, [token]);

  const handleResponse = async (responseType) => {
    setIsSubmitting(true);
    try {
      await api.post(`/api/service-response/${token}`, {
        response: responseType,
        catatan: catatan,
      });
      setIsSubmitted(true);
    } catch (err) {
      showErrorAlert(err.response?.data?.message || 'Gagal mengirim respons.');
      setIsSubmitting(false);
    }
  };

  if (loading) {
    return <div className="login-page-container"><p style={{color: 'white'}}>Memuat...</p></div>;
  }

  if (error) {
    return (
      <div className="login-page-container">
        <div className="login-form-card" style={{ textAlign: 'center' }}>
          <h2 style={{color: '#e53e3e'}}>Terjadi Kesalahan</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }
  
  if (isSubmitted) {
    return (
        <div className="login-page-container">
            <div className="login-form-card" style={{ textAlign: 'center' }}>
                <h2 style={{color: '#28a745'}}>Terima Kasih!</h2>
                <p>Respons Anda telah kami terima. Anda bisa menutup halaman ini.</p>
            </div>
        </div>
    );
  }

  return (
    <div className="login-page-container">
      <div className="login-form-card">
      <div className="login-header">
        <img src={logo} alt="Logo Perusahaan" className="login-logo-img" />
        <h1 className="login-title">Konfirmasi Jadwal Servis</h1>
      </div>
        {serviceInfo && (
          <div style={{color: '#333'}}>
            <p>Halo, <strong>{serviceInfo.pengguna.nama}</strong>.</p>
            <p>Anda diminta untuk mengonfirmasi jadwal servis untuk kendaraan:</p>
            <div style={{backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '8px', margin: '20px 0'}}>
              <p><strong>Nomor Kendaraan:</strong> {serviceInfo.kendaraan.nomorKendaraan}</p>
              <p><strong>Jenis:</strong> {serviceInfo.kendaraan.jenis}</p>
              <p><strong>Tanggal Servis:</strong> {new Date(serviceInfo.jadwal.tanggal).toLocaleDateString('id-ID', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' })}</p>
            </div>
            <div className="form-group">
                <label>Catatan (Opsional)</label>
                <textarea rows="3" value={catatan} onChange={(e) => setCatatan(e.target.value)} placeholder="Contoh: Saya bisa servis di atas jam 1 siang."></textarea>
            </div>
          </div>
        )}
        <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
          <button onClick={() => handleResponse('jadwal_ulang')} className="btn-secondary" style={{width: '100%'}} disabled={isSubmitting}>
            {isSubmitting ? '...' : 'Minta Jadwal Ulang'}
          </button>
          <button onClick={() => handleResponse('setuju')} className="login-button" style={{width: '100%'}} disabled={isSubmitting}>
            {isSubmitting ? '...' : 'Ya, Saya Konfirmasi'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceResponsePage;